<div class="modal fade align-content-center notification-modal" id="{{ modalId() }}" data-bs-keyboard="false"
  tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true" [ngStyle]="styles">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="staticBackdropLabel">Meus Cupons</h1>
      </div>
      <div class="modal-body">
        <form [formGroup]="couponFormGroup()">
          <div class="row">
            <app-input class="col-lg-8" [id]="'coupon'" [label]="'Cupom'" [type]="InputTypeEnum.COUPON"
              [placeholder]="'Insira o cupom de desconto'" formControlName="coupon"
              (input)="transformCouponToUppercase()">
            </app-input>
            <app-button class="col-lg-4 d-flex align-items-center" [buttonOptions]="couponOptions()"
              [disabled]="controls.coupon.value?.length <= 0"
              (buttonClick)="onConfirm(controls.coupon.value)">
            </app-button>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <div class="cards">
          @for(coupon of memberCoupons(); track $index) {
          <div class="bg-white card mb-3">
            <div class="row">
              <div class="col-md-8">
                <div class="header">
                  <h3 class="title mb-4">{{ coupon.couponName }}</h3>
                </div>
                <div class="content">
                  <p class="mb-1">
                    <strong>Desconto:</strong> 
                    {{ coupon.isPercentualDiscount ? coupon.value + '%' : (coupon.value  | currency : "BRL") }}
                  </p>
                  <p class="my-1">
                    <strong>{{ getValidity(coupon) }}</strong>
                  </p>
                </div>
              </div>
              <div class="col-md-4 d-flex align-items-center">
                <button class="btn btn-outline-secondary w-100 my-3 my-md-0" 
                  style="border-radius: 25px;" (click)="onConfirm(coupon.couponName)">
                  Aplicar
                </button>
              </div>
            </div>
          </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>